export default {
	office_address: {
		title: '사무실 주소',
		address: '대한민국 서울특별시 중구 남대문로 39',
	},
	connect: {
		title: '연락하기',
		phone: {
			label: '+82 2-852-2548',
			alt: '전화 아이콘',
		},
		whatsapp: {
			label: '+82 2-852-2548',
			alt: '왓츠앱 아이콘',
		},
		email: {
			support: 'support[at]jpworldpay.com',
			info: 'info[at]jpworldpay.com',
			alt: '이메일 아이콘',
		},
	},
	navigation: {
		individual: {
			title: '개인',
			menu_items: {
				online_shopping: '온라인 쇼핑',
				offline_kiosk: '오프라인 키오스크',
				pay_with_qr: 'QR코드 결제',
				transaction_cashback: '거래 및 캐시백',
				send_asset: '자산 보내기',
				asset_request: '자산 요청',
				get_deposit: '예치금 받기',
				fee: '수수료',
				wallet: '지갑',
				account: '계정',
				sell: '판매',
				exchanging_currency: '환전',
			},
		},
		business: {
			title: '비즈니스',
			menu_items: {
				getting_started: '시작하기',
				accepting_payment: '결제 수락',
				make_payment: '결제하기',
				risk_management: '리스크 관리',
				about_company: '회사 소개',
				platforms_features: '플랫폼 및 기능',
				payment_method: '결제_방법',
				global_payment: '결제 수단',
				global_processing: '글로벌 결제 처리',
			},
		},
		other_links: {
			title: '기타 링크',
			menu_items: {
				about: 'JPWorldPay 소개',
				get_deposit: '예치금 받기',
				development: '개발',
				customer_service: '고객 서비스',
				testimonial: '고객 후기',
				contact: '문의하기',
			},
		},
		terms_policy: {
			title: '약관 및 정책',
			menu_items: {
				privacy: '개인정보 처리방침',
				cookies: '쿠키 정책',
				terms: '이용약관',
			},
		},
	},
	social_media: {
		title: '팔로우하기',
		platforms: {
			facebook: {
				label: '페이스북',
				alt: '페이스북 아이콘',
			},
			twitter: {
				label: '트위터',
				alt: '트위터 아이콘',
			},
			linkedin: {
				label: '링크드인',
				alt: '링크드인 아이콘',
			},
			youtube: {
				label: '유튜브',
				alt: '유튜브 아이콘',
			},
		},
	},
	copyright: {
		text: 'ⓒ JP WORLD Pay. 모든 권리 보유.',
	},
	accessibility: {
		logo_alt: 'JPWorldPay 푸터 로고',
	},
};
